<template>
  <div class="video-box">
    <div class="video-box-bg"></div>
    <div id="aduio_container" class="video-area" style="">
      <audio
              :src="`./audio/${audioSrc}.mp3`"
              class="audio-box"
              autoplay
              preload=""
              controlsList="nodownload"
              controls
      ></audio>
      <div class="video-close" @click="closeVideo"></div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      audioSrc: "",
    },
    data() {
      return {};
    },
    mounted() {},
    methods: {
      closeVideo() {
        this.$emit("closeAudio");
      },
    },
    created() {},
  };
</script>

<style lang="scss" scoped>
  .video-box {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    .video-box-bg {
      width: 100%;
      height: 100%;
      background-color: rgba($color: #000000, $alpha: 0.6);
      position: absolute;
      top: 0;
      left: 0;
    }
    .video-area {
      width: 960px;
      height: 540px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -480px;
      margin-top: -270px;
      .audio-box {
        width: 300px;
        height: 100px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -150px;
        margin-top: -50px;
      }
      .video-close {
        position: absolute;
        top: 55%;
        left: 31%;
        margin-left: 170px;
        margin-top: -80px;
        width: 40px;
        height: 40px;
        background: url("../../assets/img/close-btn.png") no-repeat;
        background-size: 100% 100%;
        cursor: pointer;
        z-index: 1000;
      }
    }
  }
</style>